module.exports = __webpack_public_path__ + "static/media/back-button-icon-dark.7e2aeb5c.svg";